import Image from 'next/image';

interface LogoProps {
  size?: 'sm' | 'md' | 'menuSp' | 'lg' | 'xl';
  className?: string;
}

const sizeConfig = {
  sm: { width: 62, height: 11 },    // SP版ヘッダーのロゴサイズ
  md: { width: 124, height: 26 },   // PC版サイドバー・ヘッダーのロゴサイズ
  menuSp: { width: 96, height: 20 }, // SP版メニューオーバーレイのロゴサイズ
  lg: { width: 284, height: 56 },   // 64px相当の高さ
  xl: { width: 400, height: 84 },   // Figmaデザインの最大サイズ
};

export default function Logo({ size = 'sm', className = '' }: LogoProps) {
  const { width, height } = sizeConfig[size];

  return (
    <Image
      src="/logo.svg"
      alt="atosapo"
      width={width}
      height={height}
      className={className}
      data-testid="logo"
      priority
    />
  );
}
